import React, { Component } from 'react'
import AppPortal from 'components/UI/AppPortal'
import Notification from 'components/UI/Notification'
import Overlay from 'components/UI/Overlay'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { getDateAsText, getDateAndMonth } from 'utilities/date'

class DeliveryDateChangedNotification extends Component {
    hide() {
        this.props.dispatch({ type: 'CLOSE_DELIVERY_DATE_CHANGED_NOTIFICATION' })
    }

    render() {
        const { show, deliveryDate, t } = this.props

        if (!show) return null

        const text = t('deliveryDateChangedNotificationText', {
            dateAsText: getDateAsText(deliveryDate, true, true),
            dateAsDate: getDateAndMonth(deliveryDate, true),
        })

        return (
            <AppPortal>
                <Overlay onClick={() => this.hide()}>
                    <Notification
                        title={t('deliveryDateChangedNotificationHeading')}
                        onClose={() => this.hide()}
                    >
                        <p dangerouslySetInnerHTML={{ __html: text }} />
                    </Notification>
                </Overlay>
            </AppPortal>
        )
    }
}

DeliveryDateChangedNotification.propTypes = {
    show: PropTypes.bool,
    deliveryDate: PropTypes.string,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

function mapStateToProps({ checkout, ui }) {
    return {
        show: ui.showDeliveryDateChangeNotification,
        deliveryDate: checkout.deliveryDate,
    }
}

export default connect(mapStateToProps)(withTranslation()(DeliveryDateChangedNotification))
